'use strict';

angular.module('amexReconciliationApp')
  .component('selectedTransactionCountDisplay', {
    templateUrl: 'scripts/views/components/selected-transaction-count-display.html',
    bindings: {
      totalCount: '<',
      displayCurrency: '<',
      displayDifferentCurrency:'<',
      differentCurrency:'<'
    },
    controller: function (SelectedTransactionService, UserModel) {
      var self = this;

      self.currency = 'USD';
      
      self.getAllSelectedTransactionsCount = SelectedTransactionService.selectedTransactionsCount;

      self.getAllSelectedTransactionsSum = SelectedTransactionService.selectedTransactionsSum;

      self.getAllTransactionsMultiCurrencySum = SelectedTransactionService.selectedTransactionsMultiCurrencySum;
      
      self.getCurrencyFormat = UserModel.getCurrencyFormat;
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/selectedTransactionCountDisplay.js
// module id = 478
// module chunks = 0